// @flow

// more will soon follow
// eslint-disable-next-line import/prefer-default-export
export { default as GeneralRequest } from './GeneralRequest';
